import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// Fancy Button with animations - can be customized based on ReactBits.dev designs
const FancyButtonStyled = styled(Button)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '0',
    height: '0',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.3)',
    transform: 'translate(-50%, -50%)',
    transition: 'width 0.6s, height 0.6s',
  },
  '&:hover::before': {
    width: '300px',
    height: '300px',
  },
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
}));

interface FancyButtonProps extends ButtonProps {
  variant?: 'contained' | 'outlined' | 'text';
  children: React.ReactNode;
}

export const FancyButton: React.FC<FancyButtonProps> = ({ children, ...props }) => {
  return (
    <FancyButtonStyled {...props}>
      {children}
    </FancyButtonStyled>
  );
};

export default FancyButton;









